import { Button, Grid } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { Field } from "formik";
import { TextField } from 'formik-material-ui';
import { useContext } from "react";
import { customerContext } from "../CustomerContext";


let CustomerForm = () => {
    let context = useContext(customerContext)


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="email"
                        type="email"
                        label="Email"
                        variant="outlined"
                        fullWidth
                        disabled={!context.isNew}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="firstName"
                        label="First Name"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="lastName"
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>


                <Grid container>
                    <Grid item xs={6}>
                        <Field
                            component={TextField}
                            name="m3Id"
                            label="M3 Id"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Field
                            component={TextField}
                            name="companyName"
                            label="Company Name"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default CustomerForm;